import createDuck from '../../../lib/ducks/remoteDuck'
import Payment from '../../../lib/api/payment'

export default createDuck({
  namespace: 'checkout',
  store: 'checkoutPaymentMethod',
  fetchCallback: (options) => Payment.handleFetch(options),
})
